import loadable from '@loadable/component';

const EntitiesPage = loadable(() => import('./page'));
const EntityDashboardPage = loadable(() => import('./[id]/page'));

export const routes = [
  {
    path: '',
    element: <EntitiesPage />,
  },
  {
    path: ':id',
    element: <EntityDashboardPage />,
  },
];
